export default "__VITE_ASSET__DlduV6oX__"